export default __webpack_public_path__ + "static/media/92.b278655a.jpg";